import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CSSTransition } from 'react-transition-group'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import TextLink from 'components/text_link/text_link'

import styles from './information_top.scss'

import iconClose from '../../../assets/global/global_close.svg'

let timeout

class InformationTop extends Component {

	constructor(props) {
		super(props)
		this.handleClose = this.handleClose.bind(this)
	}

	shouldComponentUpdate() {
		return true
	}

	hasLink() {
		return this.props.linkText && this.props.linkUrl
	}

	handleClose() {
		this.props.afterCallback()
		this.props.onInformationClose(this.props.informationId)
	}

	render() {

		clearTimeout(timeout)

		if (!this.props.showCloseBtn) {
			timeout = setTimeout(() => {
				this.handleClose()
			}, this.props.timeout)
		}

		return (
			<CSSTransition
				in={this.props.visible}
				classNames={{
					enter: styles.enter,
					enterActive: styles['enter-active'],
					exit: styles.exit,
					exitActive: styles['exit-active'],
				}}
				timeout={500}
				unmountOnExit
				style={{transitionDelay: `${this.props.delay}ms`}}
			>
				<div styleName={
					classNames({
						content: true,
						'content--is-success': this.props.styleType === 'success',
						'content--is-error': this.props.styleType === 'error',
						'content--is-warning': this.props.styleType === 'warning',
						'content--is-neutral': this.props.styleType === 'neutral',
						'content--is-info': this.props.styleType === 'info',
					})}
				>
					<div styleName='information'>
						<p styleName='information-text'>
							{this.props.children}
							{this.hasLink() &&
								<TextLink
									href={this.props.linkUrl}
									color='white'
									isUnderlined
									target='_blank'
								>
									{this.props.linkText}
								</TextLink>
							}
						</p>
					</div>
					{this.props.showCloseBtn &&
						<button styleName='close-btn' onClick={this.handleClose}>
							<img src={iconClose} styleName='close-btn-img' />
						</button>
					}
				</div>
			</CSSTransition>
		)
	}
}

InformationTop.defaultProps = {
	timeout: 5000,
	showCloseBtn: false,
	afterCallback: () => {},
	delay: 0,
	linkText: '',
	linkUrl: '',
}

InformationTop.propTypes = {
	informationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onInformationClose: PropTypes.func,
	timeout: PropTypes.number,
	children: PropTypes.node,
	visible: PropTypes.bool,
	styleType: PropTypes.string,
	afterCallback: PropTypes.func,
	delay: PropTypes.number,
	linkText: PropTypes.string,
	linkUrl: PropTypes.string,
}

export default CSSModules(InformationTop, styles, {allowMultiple: true})
